import React from "react";
import {SWIREPAY_URL} from "../../appconstants";
import ErrorPage from "../../components/error";

const Error = () => {
    return (
      <ErrorPage
        heading={'Oops!'}
        body={'Invalid url. Make sure the URL is correct and try again.'}
        url={SWIREPAY_URL}
      />
    )
};

export default Error;
